import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import "hammerjs";
import { CommonModule } from "@angular/common";
import { CdkTableModule } from "@angular/cdk/table";
import { DatePipe } from "@angular/common";
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

// import { CarouselModule } from 'primeng/carousel';
import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AppRoutes } from "./app.routing";
import { AppComponent } from "./app.component";
import { FullComponent } from "./layouts/full/full.component";
import { AppHeaderComponent } from "./layouts/full/header/header.component";
import { AppSidebarComponent } from "./layouts/full/sidebar/sidebar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DemoMaterialModule } from "./demo-material-module";

import { SharedModule } from "./shared/shared.module";
import { SpinnerComponent } from "./shared/spinner.component";
import { LandingComponent } from "./final/landing/landing.component";
import { CompiComponent } from "./final/compi/compi.component";
import { TracksComponent } from "./final/tracks/tracks.component";
import { IncentivesComponent } from "./final/incentives/incentives.component";
import { FameComponent } from "./final/fame/fame.component";
import { ContactComponent } from "./final/contact/contact.component";
import { SponsorsComponent } from "./final/sponsors/sponsors.component";
// import { StepperOverviewComponent } from './stepper-overview/stepper-overview.component';
import { matStepperAnimations } from "@angular/material/stepper";
import { MatStepper } from "@angular/material/stepper";
import { MatStepperModule } from "@angular/material/stepper";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { MatSidenav } from "@angular/material/sidenav";
import { FormComponent } from "./final/form/form.component";
import { LoginComponent } from "./final/login/login.component";
import { DashbComponent } from "./dash/dashb/dashb.component";
import { DashNavComponent } from "./dash/dash-nav/dash-nav.component";
import { IdeaComponent } from "./dash/idea/idea.component";
import { IdeasInnerComponent } from "./dash/ideas-inner/ideas-inner.component";
import { EditorModule } from "@tinymce/tinymce-angular";
import { RegComponent } from "./final/reg/reg.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { GccComponent } from "./final/gcc/gcc.component";
import { TestimonialComponent } from "./final/testimonial/testimonial.component";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { ResetComponent } from "./final/reset/reset.component";
import { SchoolsComponent } from "./final/schools/schools.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { EnergyideaComponent } from "./dash/energyidea/energyidea.component";
import { SvnitsuratComponent } from "./final/svnitsurat/svnitsurat.component";
import { ThankyouComponent } from "./final/thankyou/thankyou.component";
import { LoaderComponent } from "./final/loader/loader.component";
import { ResetPassComponent } from "./final/reset-pass/reset-pass.component";
import { WorkshopComponent } from "./final/workshop/workshop.component";
import { LoaderlightComponent } from "./final/loaderlight/loaderlight.component";
import { TimelineComponent } from "./final/timeline/timeline.component";
import { Timeline2Component } from "./final/timeline2/timeline2.component";
import { ZonalsComponent } from "./landing/zonals/zonals.component";
import { LandnavbarComponent } from "./landing/landnavbar/landnavbar.component";
import { PreregComponent } from "./final/prereg/prereg.component";
import { StructureComponent } from "./landing/structure/structure.component";
import { LandtestiComponent } from "./landing/landtesti/landtesti.component";
import { EurekacardsComponent } from "./landing/eurekacards/eurekacards.component";
import { LandComponent } from "./final/land/land.component";
import { ComingsoonComponent } from "./final/comingsoon/comingsoon.component";
import { MentorlandingComponent } from "./final/mentorlanding/mentorlanding.component";
import { MentornavbarComponent } from "./shared/mentornavbar/mentornavbar.component";
import { MentorlistComponent } from "./final/mentorlist/mentorlist.component";
import { MentorComponent } from "./final/mentor/mentor.component";
import { ZonalloginComponent } from "./final/zonallogin/zonallogin.component";
import { MentorloginComponent } from "./final/mentorlogin/mentorlogin.component";
import { MentordashComponent } from "./final/mentordash/mentordash.component";
import { SqanimationComponent } from "./final/sqanimation/sqanimation.component";
import { PastwinComponent } from "./final/pastwin/pastwin.component";
import { NewtimelineComponent } from "./landing/newtimeline/newtimeline.component";
import { MediapresComponent } from "./final/mediapres/mediapres.component";
import { NgxEditorModule } from "ngx-editor";
import { AppService } from "./services/app.service";
import { Whycard1Component } from "./landing/whycard1/whycard1.component";
// import {
//   MatIconModule, MatButtonModule, MatSidenavModule, MatToolbarModule
// } from '@angular/material';

import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { AboutusComponent } from './final/aboutus/aboutus.component';
import { SplineComponent } from './final/spline/spline.component';
import { GcctracksComponent } from './final/gcctracks/gcctracks.component';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    LandingComponent,
    CompiComponent,
    TracksComponent,
    IncentivesComponent,
    FameComponent,
    ContactComponent,
    SponsorsComponent,
    FormComponent,
    LoginComponent,
    DashbComponent,
    DashNavComponent,
    IdeaComponent,
    RegComponent,
    GccComponent,
    ResetComponent,
    ResetPassComponent,
    SchoolsComponent,
    EnergyideaComponent,
    SvnitsuratComponent,
    ThankyouComponent,
    LoaderComponent,
    LoaderlightComponent,
    WorkshopComponent,
    TimelineComponent,
    Timeline2Component,
    ZonalsComponent,
    LandnavbarComponent,
    PreregComponent,
    StructureComponent,
    LandtestiComponent,
    EurekacardsComponent,
    LandComponent,
    ComingsoonComponent,
    MentorlandingComponent,
    MentorlistComponent,
    MentorComponent,
    ZonalloginComponent,
    MentorloginComponent,
    MentordashComponent,
    SqanimationComponent,
    PastwinComponent,
    NewtimelineComponent,
    MediapresComponent,
    Whycard1Component,
    IdeasInnerComponent,
    AboutusComponent,
    SplineComponent,
    GcctracksComponent,
    // MentornavbarComponent
  ],
  imports: [
    LottieModule.forRoot({ player: playerFactory }),
    BrowserModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes, { scrollPositionRestoration: "enabled" }),
    MatStepperModule,
    MatInputModule,
    MatButtonModule,
    MatListModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    EditorModule,
    CommonModule,
    // NgxIntlTelInputModule,
    TooltipModule.forRoot(),
    // matStepperAnimations,
    // MatStepper
    NgxSpinnerModule,
    NgxEditorModule,
    // CarouselModule
  ],
  exports: [
    DashNavComponent,
    TestimonialComponent,
    LoaderComponent,
    LoaderlightComponent,
  ],

  providers: [
    DatePipe,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    AppService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
